import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import AddIcon from '@material-ui/icons/Add';
import { Link, Redirect, withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteAlert from '../Alert/DeleteAlert.jsx';
import { NotificationManager } from 'react-notifications';
import withUser from '../HOC/HOCwithUser.jsx';
import { DatePicker } from "material-ui-pickers";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";

import ReactExport from "react-export-excel";
import { Button , InputLabel, CircularProgress} from "@material-ui/core";
import TableFooter from "@material-ui/core/TableFooter";
import {
    BOOKING_TYPE_CASH, BOOKING_TYPE_CARD, BOOKING_TYPE_WALLET,
    getPaymentTypeClass,
    getPaymentType
  } from "../../utils/config/constants";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class RevenueListHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const rows = [
            {
                id: 'order',
                label: this.props.formatMessage({
                    id: 'revenue.order'
                })
            },
            {
                id: 'total_amount',
                label: this.props.formatMessage({
                    id: 'revenue.totalAmount'
                })
            },
            {
                id: 'revenue',
                label: this.props.formatMessage({
                    id: 'revenue.revenue'
                })
            },
            {
                id: 'provider_revenue',
                label: this.props.formatMessage({
                    id: 'revenue.adminRevenue'
                })
            },
            {
                id: 'payment_type',
                label: this.props.formatMessage({
                    id: 'revenue.paymentType'
                })
            },
            {
                id: 'created_at',
                label: this.props.formatMessage({
                    id: 'revenue.createdAt'
                })
            }
        ];

        const { order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow>
                    
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={
                                    row.disablePadding ? 'none' : 'default'
                                }
                                sortDirection={
                                    orderBy === row.id ? order : false
                                }
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={
                                        row.numeric
                                            ? 'bottom-end'
                                            : 'bottom-start'
                                    }
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

RevenueListHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                  color: theme.palette.secondary.main,
                  backgroundColor: lighten(theme.palette.secondary.light, 0.85)
              }
            : {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.secondary.dark
              },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.secondary.main
    },
    title: {
        flex: '0 0 auto'
    }
});

let RevenueListToolbar = props => {
    const { numSelected, classes, deleteAction, match } = props;

    return (
        <div className="db-list-com d-flex">
            <div className={classes.title + ' ds-boar-title'}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected}{' '}
                        <FormattedMessage
                            id="selected"
                            defaultMessage="selected"
                        />
                    </Typography>
                ) : (
                    <h2>
                        {' '}
                        <FormattedMessage
                            id="revenue.detail"
                            defaultMessage="Revenue Detail"
                        />
                    </h2>
                )}
            </div>
            <div className={classes.spacer} />
        </div>
    );
};
RevenueListToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired
};
RevenueListToolbar = withStyles(toolbarStyles)(RevenueListToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    tableWrapper: {
        overflowX: 'auto'
    }
});

function desc(a, b, orderBy) {
    if (orderBy === 'provider') {
        const a_provider = a.providerProfile[0].business_name || '';
        const b_provider = b.providerProfile[0].business_name || '';
        if (b_provider < a_provider) {
          return -1;
        }
        if (b_provider > a_provider) {
          return 1;
        }
  
    } else if (orderBy === 'revenue') {
      
      const a_amount = a.total_amount || 0;
      const a_adminCut = a.providerProfile[0].admin_cut || 0;
      const b_amount =  b.total_amount || 0;
      const b_adminCut = b.providerProfile[0].admin_cut || 0;
      const a_revenue = (a_amount*a_adminCut)/100 ;
      const b_revenue = (b_amount*b_adminCut)/100 ;
      if (b_revenue < a_revenue) {
        return -1;
      }
      if (b_revenue > a_revenue) {
        return 1;
      }
  
    } else if (orderBy === 'provider_revenue') {
        const a_amount = a.total_amount || 0;
        const a_adminCut = a.providerProfile[0].admin_cut || 0;
        const b_amount =  b.total_amount || 0;
        const b_adminCut = b.providerProfile[0].admin_cut || 0;
        const a_revenue = (a_amount*a_adminCut)/100 ;
        const b_revenue = (b_amount*b_adminCut)/100 ;
        const a_final_amount = Math.round(a_amount - a_revenue) ;
        const b_final_amount = Math.round(b_amount - b_revenue) ;
        if (b_final_amount < a_final_amount) {
          return -1;
        }
        if (b_final_amount > a_final_amount) {
          return 1;
        }
    
      } else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
          return 1;
      }
      return 0;
  
    }
}
function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class RevenueList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            order: 'desc',
            orderBy: 'created_at',
            selected: [],
            page: 0,
            rowsPerPage: 5,
            clickValue: '',
            item: '',
            itemId: '',
            showAlert: false,
            defaultAddressvalue: '',
            deleteAlert: false,
            selectedDeleteKey: '',
            loader:false,
            data:[],
            bookingFromDate: moment().subtract(30, 'days'),
            bookingToDate: moment(),
            fetchData: false,
            loadingButton: false,
            goToId: null,
            totalRevenue:0,
            currencySymbol : props.settings.currency ||  props.settings.doller || 'BD' ,
            paymentTypeList: [],
            selectedPaymentType: 0          
        };
    }
   async componentDidMount() {
    const paymentTypes = [
        {
          value: 0, name : 'All'
        },
        {
          value: BOOKING_TYPE_CASH, name : getPaymentType(BOOKING_TYPE_CASH)
        },
        {
          value : BOOKING_TYPE_CARD, name : getPaymentType(BOOKING_TYPE_CARD)
        },
        {
          value :BOOKING_TYPE_WALLET, name :getPaymentType(BOOKING_TYPE_WALLET)
        }
      ]
      this.setState({paymentTypeList: paymentTypes})
        const {bookingFromDate, bookingToDate, selectedPaymentType} = this.state;
        const fromDate = moment(bookingFromDate).format('DD-MM-YYYY');
        const toDate = moment(bookingToDate).format('DD-MM-YYYY')
  
        const params = {fromDate:fromDate, toDate:toDate, paymentType: selectedPaymentType};
        this.getData(params);
    }
    handleFromDateChange = date => {
        this.setState({bookingFromDate: date}, () => {
            this.getRevenue();
        });
        
      };
      handleToDateChange = date => {
        this.setState({bookingToDate: date}, () => {
            this.getRevenue();
        });
      };
      handleSelectedPaymentType = (event) => {
        this.setState({selectedPaymentType: event.target.value}, () => {
            this.getRevenue();
        });
      }
      getRevenue = async () => {
        try {
          const {bookingFromDate, bookingToDate, selectedPaymentType} = this.state;
          this.setState({loader: true, loadingButton: true, fetchData:false});
          const fromDate = moment(bookingFromDate).format('DD-MM-YYYY');
          const toDate = moment(bookingToDate).format('DD-MM-YYYY')
    
          const params = {fromDate:fromDate, toDate:toDate, paymentType: selectedPaymentType};
          this.getData(params);
        }  catch (e) {
          this.setState({loader: false, loadingButton:false});
        } 
        
      }
    getData = async (params) => {
        try {
            const response = await this.props.ProviderRevenueListAction(params);
            if (response.error) {
             this.setState({ noResponse: true, error: response.message, loader: false, loadingButton:false });
             return;
            } 
            let amount = 0;
            for (let i=0; i < response.data.length; i++) {
            const singleRecord = response.data[i];
            const revenuePrice = this.calculateProviderRevenue(singleRecord.providerProfile[0].admin_cut, singleRecord.total_amount);
            amount = parseFloat(amount) + parseFloat(revenuePrice);
            }
          this.setState({
            loadingButton: false,
            data: response.data,
            totalRevenue: amount,
          }, () => {
              this.setState({fetchData:true, loader: false,})
          });
        } catch (error) {
          this.setState({loader: false, loadingButton: false});
        }
      };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.data.length !== this.state.data.length) {
            this.setState({ data: this.state.data });
        }
    }

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.key) }));
            return;
        }
        this.setState({ selected: [] });
    };
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    calculateRevenue = (adminCut,amount) => {
        return (amount*adminCut)/100 ;
    }
    calculateProviderRevenue = (adminCut,amount) => {
      const calculated_result = (amount*adminCut)/100;
      return Math.round(amount - calculated_result) ;
    }
    actionCallbacks = (id) => {
        this.setState({ goToId: id});
    };
    
    render() {
        const { classes, match } = this.props;
        const { formatMessage } = this.props.intl;
        const {
            data,
            order,
            orderBy,
            selected,
            rowsPerPage,
            page,
            bookingFromDate,
            bookingToDate,
            fetchData,
            loadingButton,
            goToId,
            loader,
            totalRevenue,
            currencySymbol,
            selectedPaymentType,paymentTypeList
        } = this.state;
        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, data.length - page * rowsPerPage);
            if (goToId) {
                return (
                  <Redirect
                    to={{
                      pathname: `booking/detail/${goToId}`,
                    }}
                  />
                );
            }
            
        return (
            <div className="tz-2-com tz-2-main">
                <h4 className="d-flex justify-align-between">
                    <FormattedMessage
                        id="revenue"
                        defaultMessage="My Revenue"
                    />
                       
                </h4>
                <div className="row align-items-end date-picker-row-padding" style={{padding:"20px"}}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                <div className="col-md-3 col-xs-12">
                    <InputLabel htmlFor="providerId">Select Payment type</InputLabel>
                    <Select
                          fullWidth
                          name="selectedPaymentType"
                          value={selectedPaymentType}
                          onChange={this.handleSelectedPaymentType}
                        >
                            {paymentTypeList.map((item, i) => {
                            return (
                                <MenuItem value={item.value}>{item.name}</MenuItem>
                            );
                            })}
                        </Select>
              </div>
                <div className="col-md-3 col-xs-12 ">
                <InputLabel htmlFor="fromDate">From Date</InputLabel>
                  <DatePicker
                    fullWidth
                    name="fromDate"
                    placeholder="From Date"
                    label="From Date"
                    value={bookingFromDate}
                    format={"DD-MMM-YYYY"}
                    onChange={this.handleFromDateChange}
                    animateYearScrolling={false}
                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                    disabled={loadingButton ? true : false}
                    maxDate={new Date()}
                  />
                </div>
                 <div className="col-md-3 col-xs-12 ">
                 <InputLabel htmlFor="toDate">To Date</InputLabel>
                  <DatePicker
                    fullWidth
                    name="toDate"
                    placeholder="To Date"
                    label="To Date"
                    value={bookingToDate}
                    format={"DD-MMM-YYYY"}
                    onChange={this.handleToDateChange}
                    animateYearScrolling={false}
                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                    disabled={loadingButton ? true : false}
                    maxDate={new Date()}
                  />
                </div>
        </MuiPickersUtilsProvider>

            </div>
            {!fetchData && (
                    <div className="tz-2-com tz-2-main">
                    <div className=" text-center" style={{ minHeight: 200 }}>
                        <CircularProgress />
                    </div>
                    </div>)}
                {fetchData && (
                <Paper className={classes.root}>
                    <div className="center-align">
                        <h1 className="rating-text">
                       Total Revenue: {currencySymbol} {totalRevenue}
                        </h1> 
                    </div>
                <RevenueListToolbar
                        numSelected={selected.length}
                        deleteAction={this.deleteRecord}
                        match={match}
                    />
                <div
                        className={
                            classes.tableWrapper + ' db-list-com tz-db-table'
                        }
                    >
                        <Table
                            className={classes.table + ' bordered'}
                            aria-labelledby="tableTitle"
                        >
                            <RevenueListHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                formatMessage={this.props.intl.formatMessage}
                            />
                            <TableBody>
                                {stableSort(data, getSorting(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map(n => {
                                        const isSelected = this.isSelected(
                                            n.key
                                        );
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.key}
                                                selected={isSelected}
                                            >
                                               
                                                <TableCell onClick={() => this.actionCallbacks(n._id)}>
                                                    <Button variant="outlined" className="primary">
                                                        {n.token}
                                                    </Button>
                                                </TableCell>            
                                                <TableCell>
                                                {currencySymbol} {n.total_amount}
                                                </TableCell>
                                                <TableCell>{currencySymbol} {this.calculateProviderRevenue(n.providerProfile[0].admin_cut, n.total_amount)}</TableCell>
                                                <TableCell>{currencySymbol} {this.calculateRevenue(n.providerProfile[0].admin_cut, n.total_amount)}</TableCell>
                                                <TableCell className="status-cell">
                                                    <div className={getPaymentTypeClass(n.payment_type)}>
                                                        {getPaymentType(n.payment_type)}
                                                    </div>
                                                </TableCell>
                                                <TableCell>{moment(n.created_at).format('DD-MMM-YYYY')}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{ height: 49 * emptyRows }}
                                    >
                                        <TableCell colSpan={8} />
                                    </TableRow>
                                )}
                            </TableBody>
                            <TableFooter>
                        <TableRow>
                        <TableCell>
                          <ExcelFile
                          filename="revenue"
                            element={
                              <Button
                                variant="contained"
                                color="primary"
                                aria-label="Export"
                              >
                                Export
                              </Button>
                            }
                          >
                            <ExcelSheet data={data} name="export">
                              <ExcelColumn label="Order Number" value="token" />
                              <ExcelColumn label="Total Amount" value="total_amount" />
                              <ExcelColumn
                                label="Revenue"
                                value={col =>
                                  this.calculateProviderRevenue(col.providerProfile[0].admin_cut, col.total_amount)
                                }
                              />
                               <ExcelColumn
                                label="Admin Revenue"
                                value={col =>
                                  this.calculateRevenue(col.providerProfile[0].admin_cut, col.total_amount)
                                }
                              />
                              <ExcelColumn
                                label="Payment Type"
                                value={col =>
                                  getPaymentType(col.payment_type)
                                }
                              />
                              <ExcelColumn
                                label="Created At"
                                value={col =>
                                  moment(col.created_at).format("DD-MMM-YYYY")
                                }
                              />
                              
                            </ExcelSheet>
                          </ExcelFile>
                        </TableCell>
                        </TableRow>
                        </TableFooter>
                        </Table>
                    </div>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page'
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page'
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </Paper>
            )}
            </div>
        );
    }
}

RevenueList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = ({ auth,settings }) => {

    return {
        userData: auth.userData,       
        settings:settings
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(withRouter(withUser(RevenueList))));


// WEBPACK FOOTER //
// ./src/components/Providers/RevenueList.jsx